export default {
  PARTICPANT_LIST_REQUEST: 'APP/PARTICPANT_LIST/PARTICPANT_LIST_REQUEST',
  PARTICPANT_LIST_SUCCESS: 'APP/PARTICPANT_LIST/PARTICPANT_LIST_SUCCESS',
  PARTICPANT_LIST_ERROR: 'APP/PARTICPANT_LIST/PARTICPANT_LIST_ERROR',
};
